export const defaultFilters = {
  search: '',
  customerId: [],
  status: [],
  'sources.sourceType': [],
  'destinations.destinationType': []
};

export const defaultNavigation = {
  fieldName: 'priority',
  direction: -1,
  currentPage: 1,
  itemsPerPage: 1000
};
